
import { Adresse } from '@/model/adresse';
import { ArticleLieuDepart } from '@/model/article-lieu-depart';
import { AdresseCommandeSAS } from '@/model/commande/sas/adresse-commande-sas';
import { CommandeSAS } from '@/model/commande/sas/commande-sas';
import { LigneCommandeSAS } from '@/model/commande/sas/ligne-commande-sas';
import { ParamsCommande } from '@/model/params-commande';
import { RouteName } from '@/router/routes';
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';

type HistoriqueItem = {
  commande: LigneCommandeSAS,
  paramsArticle: ParamsCommande,
  ald: ArticleLieuDepart,
  details: boolean
}

export default Vue.extend({
  name: 'HistoriqueCommandes',
  props: {
    liteDisplay: {
      type: Boolean,
      default: false
    },
    referenceLigneCommande: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      loading: false,
      items: [] as HistoriqueItem[]
    };
  },
  created () {
    this.loading = true;
    if (this.articlesLieuxDepart) {
      this.init();
    } else {
      this.loadArticlesLieuxDepart().then(() => {
        this.init();
      });
    }
  },
  methods: {
    ...mapActions({
      loadArticlesLieuxDepart: 'articlesLieuxDepart/loadListe',
      loadParamsCommandeArticle: 'article/loadParamsCommandeArticle',
      loadHistoriqueCommandes: 'tiers/loadCommandes'
    }),
    makeData (commandes: LigneCommandeSAS[]) {
      for (const c of commandes) {
        const ald = this.articlesLieuxDepart.find((a: ArticleLieuDepart) => a.article.numArticle === c.numArticle && a.lieuDepart.code === c.codeLieuDepart);
        if (ald) {
          this.loadParamsCommandeArticle(ald.article.id).then((p) => {
            // const details = this.idCotation === c.cotation.id;
            const details = this.referenceLigneCommande
              ? this.referenceLigneCommande.split('-')[0] === c.numeroCommande && this.referenceLigneCommande.split('-')[1] === c.numeroLigne.toString()
              : false;
            this.items.push({ commande: c, paramsArticle: p, details, ald });
          });
        }
      }
    },
    init () {
      this.loadHistoriqueCommandes(this.tiers.numTiers)
        .then((commandes: CommandeSAS[]) => {
          let acc = [] as LigneCommandeSAS[];
          commandes.forEach(c => {
            acc = acc.concat(c.lignes);
          });
          acc = acc.sort((l1, l2) => Number(l1.dateDebutLivr) - Number(l2.dateDebutLivr));
          if (this.liteDisplay) {
            acc = acc.slice(0, 3);
          }
          this.makeData(acc);
        }).finally(() => {
          this.loading = false;
        });
    },
    showDetails (item: HistoriqueItem) {
      if (this.liteDisplay) {
        this.$router.push({ name: RouteName.MAIN_HISTORIQUE_COMMANDES, params: { referenceLigneCommande: item.commande.numeroCommande + '-' + item.commande.numeroLigne } });
      } else {
        item.details = !item.details;
      }
    },
    getTransportInfo (item: HistoriqueItem): any {
      const conditionnement = item.paramsArticle.conditionnements.find(c => c.code === item.commande.modeCamion);
      return {
        quantite: item.commande.quantite,
        libelleCamion: conditionnement.libelle,
        qteCamion: item.commande.quantite / conditionnement.facteurUniteBase
      };
    },
    getStrAdresseLivraison (item: HistoriqueItem): string {
      return this.adresseStr(item.commande.adresseLivraison);
    },
    getInfosCompte (item: HistoriqueItem): string {
      const domiciliationBancaire = item.paramsArticle.domiciliationsBancaires.find(d => parseInt(d.numDomiciliationBancaire) === item.commande.reglement.numDomiciliationBancaire);
      return domiciliationBancaire.libelle;
    },
    modeReglementStr (item: HistoriqueItem): string {
      const libelle = item.paramsArticle.modesReglement.find(m => m.codeReglement === item.commande.reglement.modeReglement).libelle;
      return libelle.toUpperCase();
    },
    adresseStr (adresse: AdresseCommandeSAS) {
      const adr1 = [adresse.ligne1?.trim(), adresse.ligne2?.trim(), adresse.ligne3?.trim()].filter(Boolean).join(', ');
      const adr2 = adresse.codepostal + ' ' + adresse.ville;
      return adr1 + (adr1 && adr2 ? ' - ' : '') + adr2;
    }
  },
  computed: {
    ...mapGetters({
      articlesLieuxDepart: 'articlesLieuxDepart/liste',
      itemsPanier: 'panier/items',
      tiers: 'tiers/infosTiers'
    })
  }
});
